import React from 'react'

const ItemDetailsContext = React.createContext()

export default ItemDetailsContext
